import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import VueAxios from 'vue-axios'
import './registerServiceWorker'

Vue.config.productionTip = false

const axios = require('axios').default

axios.defaults.baseURL =
  process.env.NODE_ENV == 'development'
    ? 'https://strapi.simplewoodgoods.com/'//'http://localhost:1337'
    : 'https://strapi.simplewoodgoods.com/'

Vue.use(VueAxios, axios)


new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
